'use strict';

const jQuery = require('jquery');
const _ = require('lodash');

const autocompleteTpl = require('./template/autocomplete.hbs');

module.exports.render = function(config) {
    config.classes = config.classes || '';
    config.icon = config.icon || 'search';

    let $element = jQuery(autocompleteTpl(config));
	let $input = $element.find('input[name="autocomplete"]');
    let $inputId = $element.find('input[name="item_id"]');
    let mergedConfig = _.merge({
				'appendTo': $element,
				'response': function(event, object) {
						if (object.content.length === 0) {
								$inputId.val('');
						}

						return event;
				},
				'messages': {
						noResults: '',
						results: function() {
								return;
						},
				},
				'minLength': 2,
		}, config.autocomplete);


    $input.autocomplete(mergedConfig);
    $element.find('ul').css('top', $input.outerHeight());

    if (mergedConfig.minLength === 0) {
		$input.on('click', function() {
			$input.autocomplete('search', '');
		});
	}

    return $element;
};
